module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VIII",
      "title": "VIII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("InterVarsity Press")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Publisher")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Jeff Crosby")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Associate Publisher, Director of Editorial")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Cindy Bunch")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Editorial Director, IVP Academic")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Jon Boyd")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Director of Production")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Benjamin M. McCoy"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "title": "IX"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "title": "X"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 66
// module chunks = 0